import axios from "axios";
import { CreateCampaignFileData } from "../types/campaign";
import {
  CreateHeaderResponse,
  CreateHeadersData,
  Import,
} from "../types/imports";
import api from "./api";

export const listImports = async (): Promise<Import[]> => {
  const response = await api.get(
    "importacao-p2-:stage/:stage/crm/getFileImport"
  );

  return response.data;
};

export const listColumns = async (link): Promise<any> => {
  const response = await axios.get(link);

  return response.data;
};

export const createHeaders = async (
  data: CreateHeadersData
): Promise<CreateHeaderResponse> => {
  const response = await api.post(
    "importacao-p2-:stage/:stage/crm/postFileHeaderInsights",
    data
  );

  return response.data.data;
};

export const createImportFile = async (
  data: CreateCampaignFileData
): Promise<string> => {
  const requestObjectData = {
    fileLength: data.fileRows,
    fileLink: data.fileUrl,
    fileName: data.fileName,
    headerLink: data.fileHeaderUrl,
    keyImport: data.identificator?.column,
    ruleImport: data.rule,
    typeImport: data.typeImport,
  };

  const response = await api.post(
    "importacao-p2-:stage/:stage/crm/postFileImportInsights",
    requestObjectData
  );

  return response.data.message;
};

export const createHeadersSales = async (
  data: CreateHeadersData
): Promise<CreateHeaderResponse> => {
  const response = await api.post(
    "importacao-p2-:stage/:stage/crm/postFileHeader",
    data
  );

  return response.data.data;
};

export const createImportFileSales = async (
  data: CreateCampaignFileData
): Promise<string> => {
  const requestObjectData = {
    fileLength: data.fileRows,
    fileLink: data.fileUrl,
    fileName: data.fileName,
    headerLink: data.fileHeaderUrl,
    keyImport: data.identificator?.column,
    ruleImport: data.rule,
    typeImport: data.typeImport,
  };

  const response = await api.post(
    "importacao-p2-:stage/:stage/crm/postFileImport",
    requestObjectData
  );

  return response.data.message;
};
